declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

export default new class PageMeasureService {
    public sendDataLayer(dataLayerData: Record<string, unknown>[]): void {
        for (const dataLayerItem of dataLayerData) {
            window.dataLayer.push(dataLayerItem);
        }
    }
}();
